var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.funnelId)?_c('CrmFunnelMemberListApi',{attrs:{"funnelId":_vm.funnelId,"companyId":_vm.companyId,"canManage":_vm.canManage}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }